import React from 'react'
import { HomeContent } from '../components'
import MainTheme from '../themes/main'

const HomePage = () => <MainTheme content={<HomeContent />} />

export default HomePage
